<!-- Icons-only display mode - just checkmarks/crosses in a row -->
@if (displayMode === 'icons-only') {
  <div class="icons-only-row">
    @for (check of reportChecks; track check) {
      <ion-icon
        [name]="check.value ? 'checkmark-circle' : 'close-circle'"
        [color]="check.value ? 'success' : 'danger'"
        size="small">
      </ion-icon>
    }
  </div>
} @else {
  <!-- Detailed display mode - vertical list with labels -->
  @if (displayMode === 'detailed') {
    <ion-list lines="none" class="ion-no-padding detailed-list">
      @for (check of reportChecks; track check; let last = $last) {
        <!--
        Two variants so the non-clickable form has no (click) at all.
        On iOS Safari tapping an ion-item with a no-op click listener
        was causing the page to scroll to the top; with the listener
        gone, taps are truly inert.
        -->
        @if (clickable && check.message) {
          <ion-item
            class="ion-no-padding ion-no-margin"
            lines="none"
            [style.border-bottom]="last ? '0' : '1px solid rgba(127, 127, 127, 0.5)'"
            style="cursor: pointer"
            (click)="openCheckAlert(check)">
            <ion-label class="ion-padding-horizontal ion-text-wrap">
              <p class="field-label">{{ check.name }}</p>
              @if (check.message) {
                <p class="field-value">{{ check.message }}</p>
              }
            </ion-label>
            @if (check.value) {
              <ion-icon color="success" name="checkmark-circle" slot="end" />
            }
            @if (!check.value) {
              <ion-icon color="danger" name="close-circle" slot="end" />
            }
          </ion-item>
        } @else {
          <ion-item class="ion-no-padding ion-no-margin"
            lines="none"
            [style.border-bottom]="last ? '0' : '1px solid rgba(127, 127, 127, 0.5)'">
            <ion-label class="ion-padding-horizontal ion-text-wrap">
              <p class="field-label">{{ check.name }}</p>
              @if (check.message) {
                <p class="field-value">{{ check.message }}</p>
              }
            </ion-label>
            @if (check.value) {
              <ion-icon color="success" name="checkmark-circle" slot="end" />
            }
            @if (!check.value) {
              <ion-icon color="danger" name="close-circle" slot="end" />
            }
          </ion-item>
        }
      }
    </ion-list>
  } @else {
    <table class="marks-table">
      <tr>
        @for (check of reportChecks; track check) {
          <th>{{ check.name }}</th>
        }
      </tr>
      <tr>
        @for (check of reportChecks; track check) {
          <td>
            @if (check.message && clickable) {
              <div class="has-message">
                <div class="message-indicator">❗️</div>
                @if (check.value) {
                  <ion-icon [style.cursor]="'pointer'"
                    (click)="openCheckAlert(check)"
                    color="success"
                    name="checkmark-circle"
                    slot="end" />
                } @else {
                  <ion-icon [style.cursor]="'pointer'"
                    (click)="openCheckAlert(check)"
                    color="danger"
                    name="close-circle"
                    slot="end" />
                  }
                </div>
              } @else if (check.message && !clickable) {
                <div class="has-message">
                  <div class="message-indicator">❗️</div>
                  @if (check.value) {
                    <ion-icon
                      color="success"
                      name="checkmark-circle"
                      slot="end" />
                  } @else {
                    <ion-icon color="danger" name="close-circle" slot="end" />
                  }
                </div>
              } @else {
                @if (check.value) {
                  <ion-icon color="success" name="checkmark-circle" slot="end" />
                } @else {
                  <ion-icon color="danger" name="close-circle" slot="end" />
                }
              }
            </td>
          }
        </tr>
      </table>
    }
    <!-- Compact display mode - horizontal table -->
  }

